import request from '@/http/module/request'
import store from '@/store'

export function requestHomeInfo () {
  const url = '/api/home'

  const config = {
    headers: {
      'Authorization': 'Bearer ' + store.getters.token
    }
  }

  const params = {}

  return request.post(url, params, config)
}



// WEBPACK FOOTER //
// ./src/http/api/main.js